import type { ReactNode } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  selecionado: boolean;
  titulo: string;
  descricao?: string;
  children?: ReactNode;
  aoSelecionar: () => void;
  className?: string;
  /** Marca visual à esquerda (amostra de cor, ícone, etc.). */
  marca?: ReactNode;
  desabilitado?: boolean;
}

/** Cartão clicável usado em todas as escolhas exclusivas do assistente. */
export function CartaoOpcao({
  selecionado,
  titulo,
  descricao,
  children,
  aoSelecionar,
  className,
  marca,
  desabilitado,
}: Props) {
  return (
    <button
      type="button"
      onClick={aoSelecionar}
      disabled={desabilitado}
      aria-pressed={selecionado}
      className={cn(
        'group relative w-full rounded-lg border bg-card p-4 text-left transition-all',
        'hover:border-primary/40 hover:shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50',
        selecionado ? 'border-primary bg-primary/[0.04] shadow-sm ring-1 ring-primary/25' : 'border-border',
        desabilitado && 'cursor-not-allowed opacity-55',
        className,
      )}
    >
      <div className="flex items-start gap-3">
        {marca ? <div className="mt-0.5 shrink-0">{marca}</div> : null}
        <div className="min-w-0 flex-1 space-y-1">
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold leading-tight">{titulo}</span>
            {selecionado ? (
              <span className="ml-auto inline-flex size-4 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground">
                <Check className="size-3" strokeWidth={3} />
              </span>
            ) : null}
          </div>
          {descricao ? <p className="text-xs leading-relaxed text-muted-foreground">{descricao}</p> : null}
          {children ? <div className="pt-2">{children}</div> : null}
        </div>
      </div>
    </button>
  );
}
